import { t } from '@glory/i18n';
import type { ReactNode } from 'react';

import { LogoBadge } from './logo.tsx';

function Wordmark({ className }: { className?: string }) {
  return (
    <span className={className}>
      {t('app.logo')}
      <span className="text-accent">{t('app.logoDot')}</span>
      {t('app.logoSuffix')}
    </span>
  );
}

/**
 * Экраны без оболочки: вход, приглашение. Слева — чёрная панель со знаком студии,
 * справа — форма; на телефоне остаётся только форма со знаком сверху.
 */
export function AuthLayout({
  title,
  lead,
  children,
  footer,
}: {
  title: ReactNode;
  lead?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="grid min-h-dvh bg-bg text-text md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
      <aside className="relative hidden flex-col justify-between overflow-hidden bg-sidebar p-10 text-white md:flex">
        <LogoBadge className="inline-grid size-12 place-items-center rounded-lg bg-white text-[#0D0D0D]" />
        <div className="flex flex-col gap-4">
          <Wordmark className="font-display text-[clamp(3rem,7vw,6rem)] leading-none font-bold tracking-[-0.02em]" />
          <p className="max-w-xs text-lead text-sidebar-text">{t('auth.brandLine')}</p>
        </div>
      </aside>
      <main className="flex items-center justify-center px-4 py-10 sm:px-8">
        <div className="flex w-full max-w-sm flex-col gap-6">
          <div className="flex items-center gap-2 md:hidden">
            <LogoBadge className="inline-grid size-9 place-items-center rounded-md bg-white text-[#0D0D0D] ring-1 ring-black/10" />
            <Wordmark className="font-display text-title font-bold" />
          </div>
          <div className="flex flex-col gap-1.5">
            <h1 className="font-display text-heading font-bold">{title}</h1>
            {lead ? <p className="text-muted">{lead}</p> : null}
          </div>
          {children}
          {footer ? <div className="text-small text-muted">{footer}</div> : null}
        </div>
      </main>
    </div>
  );
}
